export default __webpack_public_path__ + "static/media/alin_oltean.f2f1467c.png";